module.exports = __webpack_public_path__ + "media/v2/components/PrizesPage/shared/img/5-66e99c238b142c184a4ac0bb9881c09c.png";